<template>
  <header>
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
      <ul>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
      <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
      <ul style="list-style: none">
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="Gt_Dvc" href="/chuongtrinhtaitroxathidiem">{{ currentLanguage.item_footer_5 }}
          </a>
        </li>
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="banHangQRdong" href="/thanhtoanthongminh">{{
            currentLanguage.item_footer_0
          }}</a>
        </li>
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="Gd_Yte" href="/giaoduc">{{ currentLanguage.item_footer_4 }}
          </a>
        </li>

        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="dichVuThuChiHo" href="/giaothongthongminh">{{ currentLanguage.item_footer_3
          }}</a>
        </li>

        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="giaiPhapChuyenDoiSo" href="/y-te">{{ currentLanguage.item_footer_1
          }}</a>
        </li>
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="thesinhtrachoc" href="/dichvucong-nongnghiepthongminh">{{
            currentLanguage.item_footer_2 }}</a>
        </li>

        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="thietBiVaDichVu" href="/thietbivadichvu">{{ currentLanguage.item_footer_6 }}
          </a>
        </li>

        <li>
          <a class="f-s--title" id="congTy" href="/congty">{{
            currentLanguage.item_footer_7
          }}</a>
        </li>
      </ul>
    </nav>
    <div class="menu_right" style="display: flex">
      <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img
          src="img/img-item-vimass-2022/co/vi-VN.gif" />
      </a>
      <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px"
          src="img/img-item-vimass-2022/co/us.png" />
      </a>
      <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
          src="img/img-item-vimass-2022/co/cn.jpg" />
      </a>
      <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
          src="img/img-item-vimass-2022/co/kr.jpg" />
      </a>

      <span class="clickShow" style="color: #ffffff; cursor: pointer; margin: auto; padding: 5px">
        <i class="fa fa-ellipsis-h" aria-hidden="true"></i></span>
      <div class="showCo" style="display: none; margin: auto">
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/indo.jpg" />
        </a>
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/tl.png" />
        </a>
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/thailan.png" />
        </a>
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/hu.jpg" />
        </a>
      </div>
      <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px"
          src="img/home-icon-white-8.jpg" />
      </a>
    </div>
  </header>
  <div class="wrapper row3">
    <main class="hoc container-fluid clear bv">
      <div style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHeThong"></div>
        <div v-html="contentHeThong">
        </div>       

      </div>
    </main>
  </div>
  <FooterView></FooterView>
</template>

<script>
import { languages } from "@/components/languages";
import axios from "axios";
import { apiChiTietBaiVietVer2 } from "@/components/listService";
import FooterView from "@/views/Vimass/Footer/FooterView.vue";
export default {
  components: {
    FooterView,
  },
  data() {
    return {
      currentLanguage: languages.vi,
      isMenuVisible: false,

      lang: "",
      base64: "",
      base64Title: "",
      //title
      titleHeThong: "",
      //content
      contentHeThong: "",
      hasMounted: false,
      idBaiViet: "",
    };
  },

  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }

    let url = window.location.href;
    let pathArray = url.split("/");
    let lang1 = pathArray[pathArray.length - 3];
    localStorage.setItem("languages", lang1);
    const lang = localStorage.getItem("languages") || "vi";
    console.log(lang1 + "   a");
 
    this.lang = lang;
       if (this.lang == "vi") {
      document.title = "Vimass.vn - Tin tức";
    } else if (this.lang == "en") {
      document.title = "Vimass.vn - News";
    } else if (this.lang == "cn") {
      document.title = "Vimass.vn - 帖子";
    } else if (this.lang == "kr") {
      document.title = "Vimass.vn - 게시물";
    }
    // document.getElementById("urlHome").setAttribute("href", this.lang);
      document
      .getElementById("banHangQRdong")
      .setAttribute("href", lang + "/thanhtoanthongminh");

    document
      .getElementById("dichVuThuChiHo")
      .setAttribute("href", lang + "/giaothongthongminh");

    document
      .getElementById("giaiPhapChuyenDoiSo")
      .setAttribute("href", lang + "/y-te");

    document.getElementById("Gd_Yte").setAttribute("href", lang + "/giaoduc");
    document
      .getElementById("Gt_Dvc")
      .setAttribute("href", lang + "/chuongtrinhtaitroxathidiem");
    document
      .getElementById("thesinhtrachoc")
      .setAttribute("href", lang + "/dichvucong-nongnghiepthongminh");

    document
      .getElementById("thietBiVaDichVu")
      .setAttribute("href", lang + "/thietbivadichvu");
    document.getElementById("congTy").setAttribute("href", lang + "/congty");

    if (!this.hasMounted) {
      this.hasMounted = true;
      this.idBaiViet = this.$route.params.idTitleVi;
      console.log("this.$route.params.id; ", this.$route.params.idTitleVi);

      if (this.lang) {
        // Kiểm tra giá trị của this.lang trước khi sử dụng
        this.$router.push({
          path: "/" + this.lang + "/giao-duc/" + this.idBaiViet,
        });
      }
    }

    // if (this.$refs.manHinhChinh) {
    //   const imgElement = this.$refs.manHinhChinh;
    //   imgElement.addEventListener("click", this.handleClick);
    //   console.log("Ref tồn tại");
    // } else {
    //   console.log("Ref không tồn tại");
    // }

    const hash = this.idBaiViet
    console.log("hash ", hash);

    if (hash && hash.includes("bo-thu-vien")) {
      const bothuvienElement = document.getElementById("activeBoThuVien");
      const titleBothuVien = document.getElementsByClassName("title-bai-viet");
      if (bothuvienElement) {
        bothuvienElement.classList.add("topmenuactive");
        if (titleBothuVien.length > 0) {
          titleBothuVien[0].classList.add("d-none");
        }
      }

    }
    if (this.lang && languages[this.lang]) {
      this.currentLanguage = languages[this.lang];
    }    
    this.performPostRequest(this.idBaiViet);
  },

  methods: {
    handleClick() {
      // Xử lý sự kiện click ở đây
      console.log("Đã click vào màn hình chính");
    },

    toggleMenu() {
      this.isMenuVisible = true;
    },
    changeLanguage(lang) {
      // this.currentLanguage = languages[lang];
      // localStorage.setItem("languages", lang);
      // window.location.reload();
      // const currentPath = this.$route.fullPath;
      const idBaiViet = this.idBaiViet; // Đảm bảo biến idBaiViet đã được định nghĩa ở nơi khác

      // Cập nhật URL mới với ngôn ngữ và id bài viết
      const newPath = "/" + lang + "/giao-duc/" + idBaiViet;

      // Reload trang với URL mới
      window.location.href = newPath;
    },

    async performPostRequest(id) {
      this.lang = localStorage.getItem("languages") || "vi";
      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiVietVer2, {
          idTitleVi: id,
          langId: "0",
          
        });

        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        } else {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        }
        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        this.titleHeThong = decodeURIComponent(escape(title));
        this.contentHeThong = decodeURIComponent(escape(decodedString));
      } catch (error) {
        console.error("Error:", error);
      }
    },    
  },
};
</script>
<style scoped>
.f-s--title {
  font-size: 16.4px;
}
</style>
